import { Routes } from '@angular/router';
import { FeedbackDialogComponent } from './feedback-dialog.component';

export const FEEDBACK_DIALOG_ROUTES: Routes = [
    {
        path: 'feedback-dialog',
        component: FeedbackDialogComponent
    }
];
